import {GameInfoModule} from 'src/info/GameInfoModule';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {RecodeInfoModuleFreeSpinsState} from '@fantasmagames/slot/src/modules/hud/info/recode/states/RecodeInfoModuleFreeSpinsState';
import {GameWinUtils} from 'src/logic/GameWinUtils';

export class GameInfoModuleFreeSpinsState extends RecodeInfoModuleFreeSpinsState {

	public onEnterState(): void {
		super.onEnterState();
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		const win = logic.currentSpinWin;

		if (logic.isFreeSpinsJustWon()) {
			(this.module as GameInfoModule).updateWin(win);
		} else if (logic.isFreeSpinsStarted && logic.hasRestore) {
			(this.module as GameInfoModule).updateWin(logic.getTransTotalWin() - win);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onAfterMultiplierCountingFinished);
	}

	protected onAfterMultiplierCountingFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		const win: number = logic.getTransTotalWin();

		this.updateWin(win);
	}

	protected onSpinResponse(): void {
	}

	protected onNoWin(): void {
	}

	protected onWinShownToPlayer(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		const win: number = logic.getTransTotalWin();

		if (logic.getLastAvalancheMultiplier() === 1) {
			this.updateWin(win);
		}
	}

	protected onCanSpin(): void {
	}

	protected onBigWinFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		const spinWin: number = logic.getTransTotalWin();

		this.updateWin(spinWin);
	}

	protected onWinCountupFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

		if (!GameWinUtils.isBigWinWithMultiplier(logic)) {
			this.updateData();
		}
	}

	protected updateData(): void {
		const win = this.module.logic.getWin();
		this.updateWin(win);
	}
}



// WEBPACK FOOTER //
// ./src/info/states/GameInfoModuleFreeSpinsState.ts